import React from 'react';
import './Loader.css';

const Loading = ({ text = '' }) => {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/10 backdrop-blur-sm"
      style={{ pointerEvents: 'all' }}
    >
      <div className="flex flex-col items-center justify-center space-y-4 p-6">
        <div className="relative rounded-lg bg-white p-3">
          <div className="loader" />
        </div>
        {text && (
          <div className="mt-2 rounded bg-white px-2 py-1 text-center">
            <p className="text-gray-700 font-medium">{text}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Loading;
